import React from 'react';
import { RenderAppropriate } from '../../internals/RenderAppropriate';

import { HeadingTwoStyle } from '../../styles/typography/heading.styles';

interface TwoProps {
    children?: React.ReactNode;
    component?: React.ElementType;
    [key: string]: any;
}

interface TwoComponent extends React.FC<TwoProps> {
    Style?: typeof HeadingTwoStyle;
}

export const Two: TwoComponent = ({ children, component: Component, ...rest }) =>
    RenderAppropriate(HeadingTwoStyle, rest, children, Component);

Two.Style = HeadingTwoStyle;
